<template>
    <div>
      <h2>로그인</h2>
      <p id="login">
        텐스에듀의 학원 관리 프로그램은 학원마다 별도의 db와 url이 제공됩니다.<br/>
        따라서 제공되는 url로 접속한 후<br/>
        (예를 들어 https://aca.exx.kr 와 같은 url로 접속한 후), <br/>
        신청 시 기입했던 루트관리자 ID / PW를 입력하여 로그인 합니다.<br/>
      </p>
      <div><img src="@/assets/aca/manual/login/login.jpg" /></div>
      
      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '로그인', link: '#login' },
            ]
        }
    },
    computed :{
    },
    methods : {
    },
    beforeMount() {
    }
}
</script>


